import { useRequest } from 'ahooks'
import { Form, FormInstance, Input } from 'antd'
import React from 'react'

import { JiraColumnProps } from '@/modules/project/project-detail/project-jql/project-jql-table-config.component'
import { ResourceType } from '@/schemas'

import { JQLTable, JiraResp } from './jql-table.component'

interface JQLEditContentProps {
  columns: JiraColumnProps[]
  form: FormInstance<any>
  jql?: string | null
  onSubmit: (jql: string) => void
  entity: { name: string; type: ResourceType }
}

export const JQLEditContent: React.FC<JQLEditContentProps> = ({ form, jql: initialJql, onSubmit, columns, entity }) => {
  const [jql, setJql] = React.useState(initialJql)

  const { data, loading, run } = useRequest<JiraResp>(
    {
      url: '/api/project/getJira',
      params: {
        jql,
      },
    },
    {
      manual: true,
      refreshOnWindowFocus: false,
      debounceInterval: 800,
    }
  )

  const onFinish = () => {
    form.validateFields().then((data) => {
      onSubmit(data.jql)
    })
  }

  const onChange = () => {
    setJql(form.getFieldValue('jql'))
  }

  // ready和refreshDeps配合时只会在第一次生效
  // https://github.com/alibaba/hooks/issues/468
  React.useEffect(() => {
    if (jql) {
      run()
    }
  }, [jql])

  return (
    <>
      <Form form={form} onFieldsChange={onChange} onFinish={onFinish} initialValues={{ jql }}>
        <Form.Item label='JQL' name='jql' rules={[{ type: 'string', whitespace: true }]}>
          <Input allowClear />
        </Form.Item>
      </Form>
      <JQLTable columns={columns} issues={data?.issues || []} loading={loading} entity={entity} />
    </>
  )
}
